import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import CalculatorSidebar from '@/modules/Calculator/components/CalculatorSidebar.vue';
import CalculatorTopBar from '@/modules/Calculator/components/CalculatorTopBar.vue';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import router from '@/router';
import { RouteNames } from '@/enums/routes/RouteNames';


export default /*#__PURE__*/_defineComponent({
  __name: 'Calculator',
  setup(__props) {

const clearAllEvent = EventBusEvents.clearCalculator;
const hasProductView = ref(false);

watch(
    () => router.currentRoute,
    (newVal) => {
        hasProductView.value = newVal.name === RouteNames.calculatorProduct;
    },
    { immediate: true, deep: true },
);

return { __sfc: true,clearAllEvent, hasProductView, CalculatorSidebar, CalculatorTopBar }
}

})